module.exports = __webpack_public_path__ + "static/media/vipul.cc1c22d7.png";